<template>
  <v-main>
    <v-container fluid>
      <div class="d-flex flex-column flex-sm-row" style="margin: 0 -12px">
        <v-col cols="12">
          <v-card outlined elevation="0">
            <v-card-title>Chamados solicitados</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4">
                  <quicksearch v-model="ticketsearch" :immediate="true"></quicksearch>
                </v-col>
                <v-col cols="6" md="4">
                  <v-select
                    label="Departamento"
                    :items="heppiSupportItems"
                    v-model="heppiSupport"
                    outlined dense hide-details multiple chips
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    label="Status"
                    :items="statusItems"
                    v-model="status"
                    outlined dense hide-details
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider />
            <div v-if="!loading && lastTickets.length === 0" class="pa-2 text-center">Nenhum ticket para o filtro solicitado</div>
            <v-list v-else class="pb-0 pt-0">
              <v-list-item v-if="!loading">
                <v-list-item-content>
                  <v-list-item-subtitle class="text-right">Mostrando {{ lastTickets.length === 100 ? 'os últimos 100 tickets' : lastTickets.length === 1 ? '1 ticket' : `${lastTickets.length} tickets` }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="!loading" />
              <template v-for="(item, index) in lastTickets">
                <v-divider v-if="index > 0" :key="'support=divider-' + index" />
                <v-list-item two-line :key="'support-item-' + index" @click="openTicketDetails(item.gid)">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.gid }}: <b>{{ item.name }}</b></v-list-item-title>
                    <v-list-item-subtitle>
                      <v-chip
                        v-for="membership in item.memberships"
                        :key="membership.project.gid"
                        x-small outlined label class="mr-1 pr-0"
                        :color="ticketStatusColor(membership.section.name)"
                      >
                        {{ membership.project.name }}
                        <v-chip x-small class="ml-2" label :color="ticketStatusColor(membership.section.name)">{{ membership.section.name }}</v-chip>
                      </v-chip>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="mt-1">
                      Turma/entidade: <b>{{ celebrationName(item) }}</b>
                      <br />
                      Última atualização: {{ item.modified_at | moment('DD/MM/YYYY HH:mm') }} <template v-if="item.due_on">| Conclusão: {{ item.due_on | moment('DD/MM/YYYY') }}</template>
                      <br />
                      Responsável: {{ item.assignee && item.assignee.name }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </template>
              <v-divider v-if="loading" />
              <v-list-item v-if="loading">
                <v-list-item-content>
                  <v-list-item-title class="text-center">Carregando...</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </div>
    </v-container>
    <support-request-dialog :openedTicket="openedTicket" @close="openedTicket = null" @updateList="getTickets(true)" />
  </v-main>
</template>

<script>
import Quicksearch from '@/components/Quicksearch'
import SupportRequestDialog from '@/components/SupportRequestDialog'
import { mapGetters } from 'vuex'

export default {
  name: 'technicalSupportPanel',
  components: {
    Quicksearch,
    SupportRequestDialog
  },
  data () {
    return {
      loading: false,
      quicksearch: '',
      ticketsearch: '',
      status: 'opened',
      heppiSupport: '',
      lastTickets: [],
      openedTicket: null,
      timeoutTicketGet: null
    }
  },
  computed: {
    ...mapGetters(['requests', 'userEmail']),
    heppiSupportItems () {
      return [
        { value: '1207826521026912', text: 'Gestão Comissão' },
        { value: '1207826522655672', text: 'Financeiro' },
        { value: '1207826522655675', text: 'Jurídico' },
        { value: '1207826522655669', text: 'Suporte' }
      ]
    },
    statusItems () {
      return [
        { value: 'opened', text: 'Em Aberto' },
        { value: 'ended', text: 'Finalizados' },
        { value: '', text: 'Todos os tickets' }
      ]
    },
    params () {
      const params = {
        resource_subtype: 'default_task',
        sort_by: 'modified_at',
        sort_ascending: false,
        opt_fields: 'name, due_on, modified_at, assignee.name, memberships.section.name, memberships.project.name, custom_fields.display_value'
      }
      if (this.heppiSupport) params['projects.any'] = this.heppiSupport.join(',')
      else params['projects.any'] = '1207826522655672,1207826521026912,1207826522655675,1207826522655669'
      if (this.status) params.completed = this.status === 'ended'
      if (this.ticketsearch) params.text = this.ticketsearch
      return params
    },
    celebrationName () {
      return (item) => {
        if (item.custom_fields) {
          const celebrationField = item.custom_fields.find(c => c.gid === '1207534182103018')
          if (celebrationField && celebrationField.display_value) {
            return celebrationField.display_value
          }
        }
        return ''
      }
    }
  },
  watch: {
    heppiSupport () {
      this.getTickets(true)
    },
    status () {
      this.getTickets(true)
    },
    ticketsearch () {
      clearTimeout(this.timeoutTicketGet)
      this.timeoutTicketGet = setTimeout(() => {
        this.getTickets(true)
      }, 700)
    }
  },
  methods: {
    openTicketDetails (item) {
      this.openedTicket = item
    },
    ticketStatusColor (status) {
      if (status === 'Finalizado') return 'success'
      if (status === 'Impedido') return 'error'
      if (status === 'Em andamento' || status === 'À fazer') return 'primary'
      return 'grey-4'
    },
    getTickets (refresh) {
      this.loading = true
      if (refresh) this.lastTickets = []
      this.$store.dispatch('asanaApi', { method: 'GET', url: 'workspaces/1202385686519626/tasks/search', params: this.params })
        .then(response => {
          this.lastTickets = [...this.lastTickets, ...response.data.filter(t => t.memberships && t.memberships.length > 0)]
        })
        .catch(() => {
          this.lastTickets = []
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.getTickets(true)
  }
}
</script>
